import Title from './Title';
import Button from './Button';
import InputArea from './InputArea';
import Input from './Input';
import Select from './Select';


const Hm = {
  Title,
  Button,
  InputArea,
  Input,
  Select,
}

export default Hm;


// WEBPACK FOOTER //
// ./src/styles/ui/index.tsx